import darkTheme from '@atlaskit/tokens/atlassian-dark';
import lightTheme from '@atlaskit/tokens/atlassian-light';
import motionTheme from '@atlaskit/tokens/atlassian-motion';
import shapeTheme from '@atlaskit/tokens/atlassian-shape';
import spacingTheme from '@atlaskit/tokens/atlassian-spacing';
import typographyTheme from '@atlaskit/tokens/atlassian-typography';

import type { TransformedTokenMerged, TransformedTokenWithAttributes } from './types';

const lightDarkTokens = lightTheme.map((lightToken) => {
	const darkToken = darkTheme.find((token) => token.name === lightToken.name);
	const mergedToken = {
		...lightToken,
		darkToken: (darkToken as TransformedTokenWithAttributes)!,
	} as TransformedTokenMerged;

	return mergedToken;
});

const typographyThemeFiltered = typographyTheme;

const newShapeTokens = shapeTheme.filter((token) => !token.attributes.deprecated);
const newMotionTokens = motionTheme.filter((token) => !token.attributes.deprecated);

const mergedTokens: TransformedTokenMerged[] = lightDarkTokens.concat(
	// @ts-expect-error this is annoying and related to the tokens defintions
	...spacingTheme,
	...typographyThemeFiltered,
	...newShapeTokens,
	...newMotionTokens,
);

export default mergedTokens;
